module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mgm mgmshare"
  }, [_c('img', {
    staticStyle: {
      "visibility": "hidden",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.ilogSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mgm-sg"
  }, [_c('div', {
    staticClass: "m-s-1"
  }, [(_vm.isInvite) ? _c('p', {
    on: {
      "click": _vm.inviteHandle
    }
  }, [_vm._v("我的邀请")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "m-s-2"
  }, [_c('div', {
    staticClass: "share-btn",
    attrs: {
      "data-ilog": "14.1503.vI4"
    },
    on: {
      "click": _vm.shareHandle
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "m-s-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-s-5"
  })]), _vm._v(" "), (_vm.isShareMark) ? _c('div', {
    staticClass: "share-mark",
    on: {
      "click": _vm.shareMarkHandle
    }
  }, [_c('div', {
    staticClass: "sm-icon"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-s-3"
  }, [_c('div', {
    staticClass: "share-text"
  }, [_c('div', {
    staticClass: "event-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "event-text"
  }, [_c('p', [_vm._v("1. "), _c('b', [_vm._v("活动时间：")])]), _vm._v(" "), _c('p', [_vm._v("2017年即日起-2017年12月21日 23:59分。")]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('b', [_vm._v("奖品：")]), _vm._v("每成功邀请好友1人即可获得88元点点免息券，上不封顶。")]), _vm._v(" "), _c('p', [_vm._v("3. "), _c('b', [_vm._v("获奖条件：")]), _vm._v("邀请的好友下载登录点点APP，完成申请并获得授信额度。")]), _vm._v(" "), _c('p', [_vm._v("4. "), _c('b', [_vm._v("奖品查看：")]), _vm._v("APP首页我的-邀请有奖-我的邀请，可查看邀请好友进度；首页我的-我的优惠券，可查看免息券详细内容。")]), _vm._v(" "), _c('p', [_vm._v("5. "), _c('b', [_vm._v("奖品使用：")]), _vm._v("点点免息券在提现时可抵用同等金额利息，具体使用方法详见 我的优惠券-免息券使用说明。")]), _vm._v(" "), _c('p', [_vm._v("6. "), _c('b', [_vm._v("奖品效期：")]), _vm._v("30天，包括领券日当天。超过有效期未使用免息券则自动失效。")]), _vm._v(" "), _c('p', [_vm._v("7. 本次活动最终解释权归众联商务所有。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0020a025"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mgmshare.vue
// module id = 184
// module chunks = 0